import profanityList from './profanityList';

/**
 * Checks if a message contains any profane words from the Portuguese (Brazil) profanity list
 * 
 * @param {string} message - The message to check for profanity
 * @returns {Object} - Contains whether the message has profanity and which words were found
 */
export const checkProfanity = (message) => {
  if (!message || typeof message !== 'string') return { hasProfanity: false, words: [] };
  
  // Convert message to lowercase for case-insensitive matching
  const lowerMessage = message.toLowerCase();
  
  // Find all profane words in the message
  const foundWords = profanityList.filter(word => {
    // Create a regex that looks for the word as a whole word
    // This prevents flagging words that contain profane words as substrings
    const regex = new RegExp(`\\b${word}\\b|\\b${word}[^\\w]|[^\\w]${word}\\b`, 'i');
    return regex.test(lowerMessage);
  });
  
  return {
    hasProfanity: foundWords.length > 0,
    words: foundWords
  };
};

/**
 * Replaces profane words in a message with asterisks
 * 
 * @param {string} message - The message containing profanity
 * @returns {string} - The cleaned message with profane words replaced by asterisks
 */
export const censorProfanity = (message) => {
  if (!message || typeof message !== 'string') return message;
  
  let censoredMessage = message;
  
  profanityList.forEach(word => {
    // Create a regex to match the whole word
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    
    // Replace each occurrence with asterisks
    censoredMessage = censoredMessage.replace(regex, '*'.repeat(word.length));
  });
  
  return censoredMessage;
};
